import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-week',
  templateUrl: './work-week.component.html'
})
export class WorkWeekComponent implements OnInit {
  public editButton:boolean=false;
  // public saveButton:boolean=false;
  constructor() { }

  ngOnInit() {
  }
  editButtonClicked(){
    this.editButton=true;
    // this.saveButton==false;
  }

  saveButtonClicked(){
    this.editButton=false;
    // this.editButton==false;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/leave/components/work-week/work-week.component.ts